import GoogleAnalyticsConfirmationModal from "./GoogleAnalyticsConfirmationModal";
import {
    PrimaryButton,
    MessageBar,
    MessageBarType,
    Spinner,
    SpinnerSize,
} from '@fluentui/react';

const GoogleAnalyticsDataPane = ({
    fetchAllGa4Properties,
    setupGa, cobrandName,
    isEditModalOpen,
    setIsEditModalOpen,
    loadingAllGa4Properties,
    errorAllGa4Properties,
    displayedGa4Properties,
    ga4Account,
    selectedPropertyForEdit,
    setSelectedPropertyForEdit,
    loadingSetupGa,
    values,
    setToastMessage,
    setShowToast,
    selectedPropertyLevel,
    setDisplayedGa4Properties,
}) => {

    return (
        <div>
            <div style={{ marginTop: '20px', border: '1px solid #e0e0e0', padding: '15px', borderRadius: '4px' }}>
                <h4 style={{ marginTop: '0px', marginBottom: '15px' }}>GA4 Properties for {cobrandName}</h4>
                {loadingAllGa4Properties && <Spinner label="Loading GA4 data..." size={SpinnerSize.medium} />}
                {errorAllGa4Properties && (
                    <MessageBar messageBarType={MessageBarType.error} isMultiline={false}>
                        Error fetching GA4 data: {errorAllGa4Properties.message || 'An unknown error occurred.'}
                    </MessageBar>
                )}
                {!loadingAllGa4Properties && !errorAllGa4Properties && displayedGa4Properties.length > 0 && (
                    <ul style={{ listStyleType: 'none', paddingLeft: '0' }}>
                        {displayedGa4Properties.map((prop, index) => (
                            <li key={prop.propertyId + index} style={{ marginBottom: '12px', padding: '10px', border: '1px solid #f0f0f0', borderRadius: '3px' }}>
                                <strong>Property ID:</strong> {prop.propertyId || 'N/A'}<br />
                                <strong>Measurement ID:</strong> {prop.measurementId || 'N/A'}<br />
                                <strong>Level:</strong> {prop.level === 'CobrandTag' ? 'Cobrand Tag' : prop.level || 'N/A'}<br />
                                {!ga4Account && prop.level !== 'CobrandTag' && (
                                    <>
                                        <br />
                                        <p>Select an account to generate Google Analytics data.</p>
                                    </>
                                )}
                                {prop.level === 'Client' && !values.clientId && (
                                    <>
                                        <br />
                                        <p>No client found for this cobrand.</p>
                                    </>
                                )}
                                {prop.level !== 'CobrandTag' && (
                                    <PrimaryButton
                                        text={`Generate ${prop.level} Google Analytics`}
                                        onClick={() => {
                                            setSelectedPropertyForEdit(prop);
                                            setIsEditModalOpen(true);
                                        }}
                                        styles={{ root: { marginTop: '10px' } }}
                                        disabled={!ga4Account || (prop.level === 'Client' && !values.clientId)}
                                    />

                                )}
                            </li>
                        ))}
                    </ul>
                )}
                {!loadingAllGa4Properties && !errorAllGa4Properties && displayedGa4Properties.length === 0 && (
                    <MessageBar messageBarType={MessageBarType.info} isMultiline={false}>
                        No GA4 data found for {cobrandName}.
                    </MessageBar>
                )}
            </div>

            {isEditModalOpen && (
                <GoogleAnalyticsConfirmationModal
                    fetchAllGa4Properties={fetchAllGa4Properties}
                    setupGa={setupGa}
                    isEditModalOpen={isEditModalOpen}
                    setIsEditModalOpen={setIsEditModalOpen}
                    selectedPropertyForEdit={selectedPropertyForEdit}
                    loadingSetupGa={loadingSetupGa}
                    ga4Account={values.ga4Account}
                    values={values}
                    setToastMessage={setToastMessage}
                    setShowToast={setShowToast}
                    selectedPropertyLevel={selectedPropertyLevel}
                    setDisplayedGa4Properties={setDisplayedGa4Properties}
                />
            )}
        </div>
    )
}
export default GoogleAnalyticsDataPane;